import { ArrowRight, Building2, ChevronRight, FileCheck2, Sprout, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type SegmentoId = 'rural' | 'conformidade' | 'grupo-economico' | 'diagnostico-agro';

interface ClientesSegmentosProps {
  produtorCount: number;
  onSelect: (id: SegmentoId) => void;
}

interface SecundarioSpec {
  id: Exclude<SegmentoId, 'rural'>;
  title: string;
  desc: string;
  icon: LucideIcon;
}

const SECUNDARIOS: SecundarioSpec[] = [
  {
    id: 'conformidade',
    title: 'Conformidade documental',
    desc: 'Documentos e pendências',
    icon: FileCheck2,
  },
  { id: 'grupo-economico', title: 'Grupo Econômico', desc: 'Grupos e vínculos', icon: Building2 },
  {
    id: 'diagnostico-agro',
    title: 'Diagnóstico Agro',
    desc: 'Diagnóstico e conformidade agro',
    icon: Sprout,
  },
];

// Seletor de segmento do módulo Clientes — layout bento: card-herói (Produtor
// Rural, com a métrica de cadastros) + coluna de cards secundários navegáveis.
export function ClientesSegmentos({ produtorCount, onSelect }: ClientesSegmentosProps) {
  return (
    <div className="flex flex-col gap-4 font-ui lg:flex-row lg:items-start">
      {/* Card-herói · Produtor Rural */}
      <button
        type="button"
        onClick={() => onSelect('rural')}
        className="relative flex h-80 w-full flex-col items-start justify-between overflow-hidden rounded-[20px] border border-border bg-surface p-7 text-left transition-colors hover:bg-[var(--nav-active-bg)] focus-visible:bg-[var(--nav-active-bg)] lg:w-[504px]"
      >
        <Users
          aria-hidden
          strokeWidth={1.5}
          className="pointer-events-none absolute -bottom-6 right-2 h-56 w-56 text-accent opacity-[0.06]"
        />
        <span className="grid h-[52px] w-[52px] place-items-center rounded-[14px] bg-accent">
          <Users strokeWidth={2} className="h-[26px] w-[26px] text-[var(--on-solid)]" />
        </span>
        <span className="flex flex-col gap-0.5">
          <span className="text-[15px] font-semibold text-[var(--accent-700)]">Produtor Rural</span>
          <span className="text-[46px] font-bold leading-[50px] text-text">
            {produtorCount.toLocaleString('pt-BR')}
          </span>
          <span className="text-[13px] text-text-muted">produtores cadastrados</span>
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-accent px-4 py-2.5 text-[13px] font-semibold text-[var(--on-solid)]">
          Acessar
          <ArrowRight strokeWidth={2} className="h-4 w-4" />
        </span>
      </button>

      {/* Coluna de segmentos secundários */}
      <div className="flex w-full flex-col gap-4 lg:w-[400px]">
        {SECUNDARIOS.map(({ id, title, desc, icon: Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => onSelect(id)}
            className="flex h-24 w-full items-center gap-3.5 rounded-2xl border border-border bg-surface p-4 text-left transition-colors hover:bg-[var(--nav-active-bg)] focus-visible:bg-[var(--nav-active-bg)]"
          >
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-[12px] bg-accent">
              <Icon strokeWidth={2} className="h-[22px] w-[22px] text-[var(--on-solid)]" />
            </span>
            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
              <span className="text-[15px] font-semibold text-text">{title}</span>
              <span className="text-[13px] text-text-muted">{desc}</span>
            </span>
            <ChevronRight strokeWidth={1.5} className="h-[18px] w-[18px] shrink-0 text-text-2" />
          </button>
        ))}
      </div>
    </div>
  );
}
